(() => {
  document.addEventListener("line-item:change:end", e => {
    handleUpdateCart(e.detail.cart);
  })

  if(window.location.pathname === '/cart') {
    document.addEventListener("DOMContentLoaded", e => {
      const target = document.getElementById('cart-form');
      if (target) {
        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'action') {
              if (!document.getElementById('bss-hide-checkout-style')) {
                const style = document.createElement('style');
                style.id = 'bss-hide-checkout-style';
                style.textContent = `
                  .bss-checkout {
                    pointer-events: none !important;
                  }
                `;
                document.head.appendChild(style);
                setTimeout(() => {
                  style.remove();
                }, 1500);
              }
            }
          }
        });
      
        observer.observe(target, {
          attributes: true,
          attributeFilter: ['action'],
        });
      }
    })
  }
  
  function handleUpdateCart(cart){
    // update total price
    try{
      for (let i=0; i<cart.items.length; ++i ) {
        const lineItem = cart.items[i];
        const item = BSS_B2B.storage.cartStorage.get(lineItem.key)
        item.quantity = lineItem.quantity;
        BSS_B2B.storage.cartStorage.set(lineItem.key, item)
      }
    } catch(e) {
      console.log(e)
    }
    BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartPriceMutate');
    // update css checkout button
    setTimeout(() => {
      const checkoutElements = BSS_B2B.utils.getCheckoutElements();
      checkoutElements.forEach((element) => {
          element.disabled = false;
          element.addCss({ pointerEvents: 'unset', cursor: 'pointer' });
      });
    }, 500)
  }
})()